module.exports = __webpack_public_path__ + "img/sv69.d06fab5d.svg";